
import React from 'react';
import { FileText, Bot, Repeat, ArrowRight } from 'lucide-react';

const SOPExplanationSection = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-[#E0F2FE] to-[#DBEAFE]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-8 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">
          1 Agent = 1 SOP
        </h2>
        
        <p className="text-xl text-center max-w-3xl mx-auto mb-12 text-gray-700">
          Each AI agent is designed to automate a specific Standard Operating Procedure (SOP), 
          transforming documented human workflows into efficient digital workers.
        </p>
        
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 max-w-4xl mx-auto">
          <div className="bg-white p-8 rounded-xl shadow-lg text-center w-full md:w-64 border border-[#0EA5E9]/20">
            <FileText className="h-16 w-16 mx-auto mb-4 text-[#0EA5E9]" />
            <h3 className="text-xl font-bold mb-3">Document SOP</h3>
            <p className="text-gray-600">Humans document standard procedures</p>
          </div>
          
          <ArrowRight className="h-8 w-8 text-[#0EA5E9] transform rotate-90 md:rotate-0" />
          
          <div className="bg-white p-8 rounded-xl shadow-lg text-center w-full md:w-64 border border-[#0EA5E9]/20">
            <Repeat className="h-16 w-16 mx-auto mb-4 text-[#6366F1]" />
            <h3 className="text-xl font-bold mb-3">Train AI</h3>
            <p className="text-gray-600">AI learns from human execution</p>
          </div>
          
          <ArrowRight className="h-8 w-8 text-[#0EA5E9] transform rotate-90 md:rotate-0" />
          
          <div className="bg-white p-8 rounded-xl shadow-lg text-center w-full md:w-64 border border-[#0EA5E9]/20">
            <Bot className="h-16 w-16 mx-auto mb-4 text-[#0EA5E9]" />
            <h3 className="text-xl font-bold mb-3">Deploy Agent</h3>
            <p className="text-gray-600">AI agent automates the procedure</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SOPExplanationSection;
